/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Wed Nov 06 2024
 **/

import { useShallow } from "zustand/react/shallow";

import usePersistStore from "./usePersistStore";
import usePersistSpace from "./usePersistSpace";

export function usePersistCurrentSpace(): V2.SpaceInfo | undefined {
	const unity = usePersistStore(useShallow((state) => state.unity));
	const spaceType = (() => {
		if (unity?.myCurrentSpace?.currentSpace?.spaceScene.sceneType?.type === "MY_ROOM") {
			return "MY_ROOM";
		}
		if (unity?.myCurrentSpace?.currentSpace?.spaceScene.sceneType?.type === "OPEN_WORLD") {
			return "OPEN_WORLD";
		}
		return "GROUP_SPACE";
	})();
	const space = usePersistSpace(unity?.myCurrentSpace?.currentSpace?.spaceId || "", spaceType);
	return space as V2.SpaceInfo | undefined;
}

export default usePersistCurrentSpace;
